import * as React from 'react';
import * as classNames from "classnames";
import { Control, Errors, LocalForm, actions } from "react-redux-form";
import * as DTOS from "../../../FeralScan.dtos";
import { withTheme } from '../../../common/withTheme';
import ModalMessage from '../../Common/Modal';
import { required } from "../../Common/validators";
import { showErrors } from "../Survey/controls/ReactReduxFormSettings";
import ValidationMessage from "../Survey/controls/ValidationMessage";

type PlotEditProps = {
    plot?: DTOS.Plot,
    lat: number,
    lng: number,
    theme?: string
}

type PlotEditActions = {
    onCreatePlot: Function
}

type PlotEditAllProps = PlotEditProps & PlotEditActions;

type PlotEditState = {
    displayConfirmation: boolean;
    name: string;
    waterBody: string;
    nearestSuburb: string;
    private: boolean;
    requestMade: boolean;
}

class PlotEdit extends React.PureComponent<PlotEditAllProps, PlotEditState> {
    formDispatch;
    constructor(props, context) {
        super(props, context);

        this.state = {
            displayConfirmation: false,
            name: undefined,
            private: false,
            requestMade: false,
            nearestSuburb: undefined,
            waterBody: undefined,
        };

        this.onPrivateChanged = this.onPrivateChanged.bind(this);
        this.onCancelPlotCreate = this.onCancelPlotCreate.bind(this);
        this.onConfirmPlotCreate = this.onConfirmPlotCreate.bind(this);
    }

    componentDidMount() {
        if (this.props.plot) {
            this.setState({ private: this.props.plot.private });
            this.formDispatch(actions.load('plot', this.props.plot));
        }

    }

    onPrivateChanged(privateSite) {
        this.setState({ private: privateSite });
    }

    onSubmit(form) {
        this.setState({
            displayConfirmation: true,
            name: form.name,
            waterBody: form.waterbody,
            nearestSuburb: form.nearestsuburb,
        });
    }

    onCancelPlotCreate() {
        this.setState({
            displayConfirmation: false,
            name: undefined,
            waterBody: undefined,
            nearestSuburb: undefined,
            private: false,
        });
    }

    onConfirmPlotCreate() {
        if (!this.state.requestMade) {
            var plot = new DTOS.Plot();
            plot.id = this.props.plot ? this.props.plot.id : undefined;
            plot.nearestSuburb = this.state.nearestSuburb;
            plot.waterBody = this.state.waterBody;
            plot.name = this.state.name;
            plot.latitude = this.props.lat;
            plot.longitude = this.props.lng;
            plot.private = this.state.private;
            this.props.onCreatePlot(plot);

            this.setState({
                displayConfirmation: false,
                requestMade: true
            });
        }
    }

    render() {

        return (
            <div>
                <LocalForm
                    model="plot"
                    onSubmit={plot => this.onSubmit(plot)}
                    getDispatch={dispatch => this.formDispatch = dispatch}
                    validateOn="submit"
                >
                    <div className="card card-plot">
                        <div className="card-header">
                            <h6>
                                {!this.props.plot ?
                                    "Create New Site" :
                                    this.props.plot.name
                                }
                            </h6>
                        </div>
                        <div className="form-group px-2 py-0 pt-2">
                            <label className="my-0">Water Body</label>
                            <Control.text
                                autoComplete="off"
                                model=".waterbody"
                                id="waterbody"
                                className={classNames(this.props.theme, "form-control form-control-sm col-12")}
                                maxLength={255}
                                validators={{
                                    required: required
                                }}
                                autoFocus
                            >
                            </Control.text>
                            <Errors
                                model=".waterbody"
                                className={classNames(this.props.theme, "invalid-feedback d-block")}
                                component={ValidationMessage}
                                messages={{
                                    required: "Please enter a water body"
                                }}
                                show={showErrors}
                            />
                        </div>

                        <div className="form-group px-2 py-0 pt-2">
                            <label className="my-0">Nearest Town/Suburb</label>
                            <Control.text
                                autoComplete="off"
                                model=".nearestsuburb"
                                id="nearestsuburb"
                                className={classNames(this.props.theme, "form-control form-control-sm col-12")}
                                maxLength={255}
                                validators={{
                                    required: required
                                }}
                                autoFocus
                            >
                            </Control.text>
                            <Errors
                                model=".nearestsuburb"
                                className={classNames(this.props.theme, "invalid-feedback d-block")}
                                component={ValidationMessage}
                                messages={{
                                    required: "Please enter a nearby town or suburb."
                                }}
                                show={showErrors}
                            />
                        </div>

                        <div className="form-group px-2 py-0 pt-2">
                            <label className="my-0">Site Name</label>
                            <Control.text
                                autoComplete="off"
                                model=".name"
                                id="name"
                                className={classNames(this.props.theme, "form-control form-control-sm col-12")}
                                maxLength={255}
                                validators={{
                                    required: required
                                }}
                                autoFocus
                            >
                            </Control.text>
                            <span className="small">For example, 100m upstream of Smith Bridge.</span>
                            <Errors
                                model=".name"
                                className={classNames(this.props.theme, "invalid-feedback d-block")}
                                component={ValidationMessage}
                                messages={{
                                    required: "Please enter a site name"
                                }}
                                show={showErrors}
                            />
                        </div>

                        <div className="form-group px-2 py-2 d-flex justify-content-between align-items-left">
                            <div>
                                <label className="my-0  align-left">Latitude</label>
                                <Control.text
                                    model=".latitude"
                                    id="latitude"
                                    className={classNames(this.props.theme, "form-control form-control-sm col-12")}
                                    placeholder="latitude"
                                    maxLength={255}
                                    value={this.props.lat.toFixed(4)}
                                    readOnly
                                >
                                </Control.text>
                            </div>
                            <div className="ml-2">
                                <label className="my-0 align-left">Longitude</label>
                                <Control.text
                                    model=".longitude"
                                    id="longitude"
                                    className={classNames(this.props.theme, "form-control form-control-sm col-12")}
                                    placeholder="longitude"
                                    maxLength={255}
                                    value={this.props.lng.toFixed(4)}
                                    readOnly
                                >
                                </Control.text>
                            </div>
                        </div>
                        <div className="form-group pl-3">
                            <div className={classNames(this.props.theme, "custom-control d-inline-block")}>
                                <input
                                    defaultChecked={this.state.private}
                                    className={classNames(this.props.theme, "custom-control-input")}
                                    id="plot.private"
                                    onChange={this.onPrivateChanged.bind(this, !this.state.private)}
                                    type="checkbox"
                                />
                                <label
                                    className={classNames(this.props.theme, "custom-control-label")}
                                    htmlFor="plot.private"
                                >
                                    Tick if site is on your own private property
                            </label>
                            </div>
                        </div>
                        <div className="form-group px-2 my-2">
                            <button className="btn btn-block btn-primary" type="submit">
                                SAVE
                            </button>
                        </div>
                    </div>
                </LocalForm>

                <ModalMessage
                    onRequestClose={this.onCancelPlotCreate}
                    onNegativeResponse={this.onCancelPlotCreate}
                    onPositiveResponse={this.onConfirmPlotCreate}
                    isOpen={this.state.displayConfirmation}
                    label="Confirm Site"
                    message={`Are you sure you wish to create the ${this.state.private ? "private" : "public"} site "${this.state.name}"?`}

                    positiveResponseLabel="Yes"
                    positiveResponseClass="btn-primary"
                    negativeResponseLabel="No"
                    negativeResponseClass="btn-secondary"
                />
            </div>
        );
    }
}

export default withTheme<PlotEditAllProps>(PlotEdit);
